import apiClient from './client';

export interface CurrencyItem {
  id: string;
  code: string;
  name: string;
  numericCode?: string;
  minorUnits: number;
  isActive: boolean;
  createdAt?: string;
}

export interface CreateCurrencyRequest {
  id?: string;
  code: string;
  name: string;
  numericCode?: string;
  minorUnits: number;
  isActive: boolean;
}

export interface UpdateCurrencyRequest {
  code: string;
  name: string;
  numericCode?: string;
  minorUnits: number;
  isActive: boolean;
}

export const currenciesCrudApi = {
  getAll: async (): Promise<CurrencyItem[]> => {
    const response = await apiClient.get('/Currency');
    return response.data;
  },

  getById: async (id: string): Promise<CurrencyItem> => {
    const response = await apiClient.get(`/Currency/${id}`);
    return response.data;
  },

  create: async (data: CreateCurrencyRequest): Promise<void> => {
    await apiClient.post('/Currency', data);
  },

  update: async (id: string, data: UpdateCurrencyRequest): Promise<void> => {
    await apiClient.put(`/Currency/${id}`, data);
  },
};
